import { Button, Loader } from '@wix/design-system';
import React from 'react';
import { useWixPatternsContainer } from '@wix/bex-core/react';
import { useEntityPageContext } from '../../providers';
import { observer } from 'mobx-react-lite';

export function _EntityPageActionButtons() {
  const { translate: t } = useWixPatternsContainer();
  const state = useEntityPageContext();

  return state.isFetching ? (
    <></>
  ) : (
    <>
      <Button
        priority="secondary"
        dataHook="entity-page-cancel-btn"
        onClick={state.onCancel.bind(state)}
      >
        {t('cairo.entityPage.header.cancel.CTA')}
      </Button>
      <Button
        dataHook="entity-page-save-btn"
        onClick={state.handleSubmit.bind(state)}
      >
        {state.submitTask.status.isLoading ? (
          <Loader size="tiny" />
        ) : (
          t('cairo.entityPage.header.save.CTA')
        )}
      </Button>
    </>
  );
}

export const EntityPageActionButtons = observer(_EntityPageActionButtons);
